import { getEnv } from "../env";
import { concatUrlPathnames } from "../sport-utils";

export function getUrlToFetch(url) {
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');

	try {
		if(new URL (window.location.origin)?.hostname?.startsWith("localhost") && apiDomain && !url.startsWith(apiDomain)) {
			return concatUrlPathnames(apiDomain,url);
		}else{
			return url;
		}
	}catch(err) {
		return url;
	}
}
